import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import logo from "../images/geointelli-q.png";
import "../styles/footer.css";
function Footer() {
  return (
    <div>
       {/* Footer */}
       <footer className="app-footer">
        <Container>
          <Row>
            <Col md={4}>
            <img 
          src={logo} 
          alt="Quantum-Energy Nexus Software" 
          className="img-fluid m-1 p-3 rounded shadow " 
        />
              <h5>Geo-Intelli-Q</h5> <hr/>
              <p>AI-Driven Quantum Network Models for Optimizing Energy / Oil / Renewable Sectors</p>
            </Col>
            <Col md={4}>
              <h5>Quick Links</h5> <hr/>
              <ul className="list-unstyled">
                <li><a href="/">Home</a></li>
                <li><a href="https://olewintechsolutons.com" target='_blank' rel='noreferrer'>Company</a></li>
                <li><a href="/about"  rel='noreferrer'>About Software</a></li>
                <li><a href="https://olewintechsolutions.com/html/contact.html" target='_blank' rel='noreferrer'>Contact Us</a></li>
              </ul>
            </Col>
            <Col md={4}>
              <h5>Contact</h5> <hr/>
              <p>Mobile: +91 8639449423 </p>
              <p>Developer Contact:- +91 8333880649 </p>
              <p>olewintechsolutions@gmail.com</p>
              <p>olewinacademy@gmail.com</p>
             
            </Col>
            
          </Row>
          <Row>
            <Col>
            <div className="footer-links text-center mx-3  gap-3 p-3">
            <li className='p-1'><a href="/careers"> careers page</a></li>
            <a href="/" className="mx-2">Feedback</a>  
            <a href="/" className="mx-2">Press</a>  
            <a href="/" className="mx-2">Meet the Team</a>  
            <a href="/" className="mx-2">Careers</a>  
            <a href="/" className="mx-2">About Us</a>  
            <a href="/" className="mx-2">Contact</a>  
            <a href="/" className="mx-2">Privacy Policy</a>  
            <a href="/" className="mx-2">Terms of Service</a>  

            </div>

            </Col>

        </Row>
          <Row>
            <Col className="text-center mt-4 text-info">
              <p>Olewin Pvt Ltd </p>
              <p className='text-white fw-bold' > <a href="https://olewingroup.com">Visit:- Olewin Group </a> </p>
              <p>&copy; 2025 All rights reserved.</p>
            </Col>
          </Row>
        </Container>
      </footer>
    </div>
  )
}

export default Footer
